import * as React from 'react';
import { connect } from 'react-redux';
import {
  standardSummarySearch,
  getStandardSummaryTypes,
  getStandardSummaryDatabases,
  viewData,
} from './redux-objects/actions';
import DataTable from '../DataTable';
import { IStandardSummary, IStandardSummaryDatabase, IStandardSummaryProgress, IStandardSummaryType } from '../../common/sharedTypes';
import ReactDOM from 'react-dom';
import { Modal, Button, ProgressBar } from 'react-bootstrap';
import moment from 'moment';
import * as urls from '../shared/urls';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { DateRangePicker } from 'react-dates';
import './assets/standardsummary.scss';
import { toast } from 'react-toastify';
import { ApiResponse } from 'apisauce';
import SelectList from '../RBSelectList/RBSelectList';
import Api from '../../services/Api';
import { GenerateStandardSummaryRequest, IStandardSummaryRequest } from './common';
import { getTableValuesByGroupName } from '../../services/Utils/IndexedDBUtils';
import { isGranted, permissions } from '../../services/permissionChecker';
import { UserInfo } from '../Login/common/defaults';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface IStandardSummaryAdminStateProps {
  results: IStandardSummary[];
  standardSummaryTypes: IStandardSummaryType[];
  standardSummaryDatabases: IStandardSummaryDatabase[];
  webServiceURL: string;
  currentUser: UserInfo;
}
export interface IStandardSummaryAdminActionProps {
  standardSummarySearch?: (url: string, params: any) => Promise<void>;
  getStandardSummaryTypes?: (url: string) => Promise<void>;
  getStandardSummaryDatabases?: (url: string) => Promise<void>;
  viewData?: (standardSummaryId: number) => Promise<void>;
}
interface IStandardSummaryAdminProps
  extends IStandardSummaryAdminStateProps,
  IStandardSummaryAdminActionProps { }

const months = [
  { id: 1, name: 'January' },
  { id: 2, name: 'February' },
  { id: 3, name: 'March' },
  { id: 4, name: 'April' },
  { id: 5, name: 'May' },
  { id: 6, name: 'June' },
  { id: 7, name: 'July' },
  { id: 8, name: 'August' },
  { id: 9, name: 'September' },
  { id: 10, name: 'October' },
  { id: 11, name: 'November' },
  { id: 12, name: 'December' }
];

const quarters = [
  { id: 1, name: '1' },
  { id: 2, name: '2' },
  { id: 3, name: '3' },
  { id: 4, name: '4' }
];

function getYears(): { id: number, name: string }[] {
  const startingYear = 2021;
  let years: number[] = [];
  for (let i = startingYear; i <= new Date().getFullYear(); i++)
    years.push(i);

  return years.map(y => ({ id: y, name: y.toString() }));
}

const years = getYears();

const initialState = {
  startDate: moment(
    moment().startOf('month').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ),
  endDate: moment(moment().endOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'),
  focusedInput: null,
  runStartDate: moment(
    moment().startOf('month').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ),
  runEndDate: moment(
    moment().endOf('month').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ),
  runDateFocusedInput: null,
  showComment: false,
  comment: '',
  selectedStandardSummaryId: null,
  selectedStandardSummaryTypeId: null,
  showNewStandardSummary: false,
  newStandardSummaryComment: '',
  newStandardSummaryTypeId: -1,
  newStandardSummaryDatabaseId: -1,
  newStandardSummaryMonth: -1,
  newStandardSummaryQuarter: -1,
  newStandardSummaryYear: -1,
  searchStandardSummaryMonth: -1,
  searchStandardSummaryQuarter: -1,
  searchStandardSummaryYear: -1,
  searchStandardSummaryTypeId: -1,
  searchStandardSummaryDatabaseId: -1,
  searchCrashKey: '',
  generatingStandardSummary: false,
  activeStandardSummaryProgress: null,
};
type IStandardSummaryAdminState = Readonly<typeof initialState>;
class StandardSummaryAdmin extends React.Component<
  IStandardSummaryAdminProps,
  IStandardSummaryAdminState
> {
  public constructor(props: IStandardSummaryAdminProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    if (!this.props.standardSummaryTypes || this.props.standardSummaryTypes.length == 0) {
      var url = urls.GET_STANDARD_SUMMARY_TYPES;
      this.props.getStandardSummaryTypes(url);
    }
    if (!this.props.standardSummaryDatabases || this.props.standardSummaryDatabases.length == 0) {
      var url = urls.GET_STANDARD_SUMMARY_DATABASES;
      this.props.getStandardSummaryDatabases(url);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  doSearch() {
    let uri = this.props.webServiceURL + urls.STANDARD_SUMMARY_SEARCH;

    var params = {
      startDate: this.state.startDate.toDate().toUTCString(),
      endDate: this.state.endDate.toDate().toUTCString(),
      month: this.state.searchStandardSummaryMonth,
      quarter: this.state.searchStandardSummaryQuarter,
      year: this.state.searchStandardSummaryYear,
      standardSummaryTypeId: this.state.searchStandardSummaryTypeId,
      db: this.state.searchStandardSummaryDatabaseId
    };

    this.props.standardSummarySearch(uri, params);
  }
  handleSearchButton(event: React.MouseEvent<HTMLElement>) {
    this.doSearch();
  }

  handleNewStandardSummaryButton(event: React.MouseEvent<HTMLElement>) {
    this.setState({ showNewStandardSummary: true });
  }

  onCloseCommentModal = () => {
    this.setState({
      showComment: false,
      selectedStandardSummaryId: null,
      selectedStandardSummaryTypeId: null,
    });
  };

  onCloseNewStandardSummaryModal = () => {
    this.setState({ showNewStandardSummary: false });
  };

  timeoutId: any;

  async onCreateNewStandardSummary() {
    this.setState({ showNewStandardSummary: false });

    const request: GenerateStandardSummaryRequest = {
      standardSummaryTypeId: this.state.newStandardSummaryTypeId,
      db: this.state.newStandardSummaryDatabaseId,
      month: this.state.newStandardSummaryMonth,
      quarter: this.state.newStandardSummaryQuarter,
      year: this.state.newStandardSummaryYear,
    };

    toast.info(`Generating standard summary ${this.state.newStandardSummaryTypeId === 3 ? '. This may take a few minutes.' : ''}`);

    Api.post('StandardSummary/GenerateStandardSummary',
      request
    ).then((response: ApiResponse<IStandardSummary>) => {
      if (response.ok) {
        const timeout = 1000;
        const pollStandardSummary = () => {
          Api.get(urls.GET_STANDARD_SUMMARY_PROGRESS, {
            standardSummaryId: response.data.id
          }).then((response: ApiResponse<IStandardSummaryProgress>) => {
            // if poll is not ok, then assume it failed
            if (!response.ok || !response.data) {
              toast.error('Failed to generate standard summary');
              this.setState({ activeStandardSummaryProgress: null });
            } else {
              // if poll is ok, check to see if completed
              if (response.data?.isCompleted) {
                toast.success('Successfully generated standard summary');
                this.setState({ activeStandardSummaryProgress: null });
                this.doSearch();
              } else {
                // if not completed, then continue polling
                this.setState({ activeStandardSummaryProgress: response.data });
                this.timeoutId = setTimeout(pollStandardSummary, timeout);
              }
            }
          })
        }

        // poll to see if it is completed
        this.timeoutId = setTimeout(pollStandardSummary, timeout);
      }
    })
  }

  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case 'newStandardSummaryDatabase':
        this.setState({ newStandardSummaryDatabaseId: el.value });
        break;
      case 'comment':
        this.setState({
          comment: el.value,
        });
        break;
      case 'newStandardSummaryComment':
        this.setState({
          newStandardSummaryComment: el.value,
        });
        break;
      case 'newStandardSummaryMonth':
        this.setState({
          newStandardSummaryMonth: el.value,
        });
        break;
      case 'newStandardSummaryQuarter':
        this.setState({
          newStandardSummaryQuarter: el.value,
        });
        break;
      case 'newStandardSummaryYear':
        this.setState({
          newStandardSummaryYear: el.value,
        });
        break;
      case 'searchStandardSummaryMonth':
        this.setState({
          searchStandardSummaryMonth: el.value,
        });
        break;
      case 'searchStandardSummaryQuarter':
        this.setState({
          searchStandardSummaryQuarter: el.value,
        });
        break;
      case 'searchStandardSummaryYear':
        this.setState({
          searchStandardSummaryYear: el.value,
        });
        break;
      case 'standardSummaryType':
        this.setState({
          newStandardSummaryTypeId: parseInt(el.value),
          newStandardSummaryMonth: -1,
          newStandardSummaryQuarter: -1,
          newStandardSummaryYear: -1,
        });
        break;
      case 'searchStandardSummaryType':
        this.setState({
          searchStandardSummaryTypeId: el.value,
        });
        break;
      case 'searchStandardSummaryDatabase':
        this.setState({
          searchStandardSummaryDatabaseId: el.value,
        });
        break;
      case 'searchCrashKey':
        this.setState({
          searchCrashKey: el.value,
        });
        break;
      default:
        break;
    }
  };

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate });
    }
  }

  handleRunDatesChanged(runStartDate, runEndDate) {
    if (runStartDate && runEndDate) {
      this.setState({ runStartDate, runEndDate });
    }
  }

  handleViewData(event: React.MouseEvent<HTMLElement>, row: IStandardSummary) {
    viewData(row.id);
  }

  public render() {
    const columnDefs = [
      {
        targets: 0,
        width: '200px',
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleViewData(cellData, rowData)}
              >
                <i className='fas fa-external-link-alt'></i> View Data
              </Button>
              {'  '}
            </div>,
            td
          ),
      },
      {
        targets: 1,
        render: function (data) {
          return moment(data).format('MM/DD/YYYY hh:mm a'); // ('MMMM Do YYYY');
        },
      },
    ];

    const columns = [
      {
        title: 'View',
        data: 'id',
      },
      {
        title: 'Created Date',
        data: 'createdDate',
      },
      {
        title: 'Type',
        data: 'standardSummaryType.name',
      },
      {
        title: 'For',
        mData: function (data: IStandardSummary, type, dataToSet) {

          var str = "";
          if (data.monthNumber && data.monthNumber > 0) {
            str += months.filter((x) => x.id == data.monthNumber)[0].name;
          }
          if (data.quarter && data.quarter > 0) {
            str += "Quarter " + data.quarter.toString();
          }
          str += " " + data.year.toString();
          return str;
        },
      },
      {
        title: 'Database',
        data: 'standardSummaryDatabase.name'
      },
    ];

    const options = {
      dom: 'frtipB',
    };

    return (
      <React.Fragment>
        <div className='app standardSummarys'>
          <div className='row'>
            <div className='col-sm-6'>
              <h3>StandardSummary</h3>
            </div>
          </div>
          <Form>
            <Form.Row>
              <Form.Group as={Col} controlId='createdDates'>
                <Form.Label>Created Date</Form.Label>
                <br />
                <DateRangePicker
                  startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                  startDateId='standardSummaryCreatedSearchsStartDate' // PropTypes.string.isRequired,
                  endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                  endDateId='standardSummaryCreatedSearchsEndDate' // PropTypes.string.isRequired,
                  onDatesChange={({ startDate, endDate }) =>
                    this.handleDatesChanged(startDate, endDate)
                  } // PropTypes.func.isRequired,
                  focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                  onFocusChange={(focusedInput) =>
                    this.setState({ focusedInput })
                  } // PropTypes.func.isRequired,
                  isOutsideRange={() => false}
                  small={true}
                  block={false}
                  minimumNights={0}
                />
              </Form.Group>
              <Form.Group controlId='exSType' as={Col}>
                <Form.Label>Date Type</Form.Label>
                {this.props.standardSummaryTypes && this.props.standardSummaryTypes.length > 0 && (
                  <SelectList
                    data={
                      this.props.standardSummaryTypes &&
                      this.props.standardSummaryTypes.length > 0 &&
                      this.props.standardSummaryTypes.map((x) => {
                        return { name: x.name, value: x.id };
                      })
                    }
                    onChange={this.handleChange}
                    datafield='searchStandardSummaryType'
                    value={this.state.searchStandardSummaryTypeId.toString()}
                    placeholder='All Types'
                  />
                )}
              </Form.Group>
              <Form.Group as={Col} controlId='smonth'>
                <Form.Label>Month</Form.Label>
                <br />
                <SelectList
                  data={months.map((x) => {
                    return { name: x.name, value: x.id };
                  })
                  }
                  onChange={this.handleChange}
                  datafield='searchStandardSummaryMonth'
                  value={this.state.searchStandardSummaryMonth.toString()}
                  placeholder='Any Month'
                />
              </Form.Group>
              <Form.Group controlId='squarter' as={Col}>
                <Form.Label>Quarter</Form.Label>
                <br />
                <SelectList
                  data={quarters.map((x) => {
                    return { name: x.name, value: x.id };
                  })
                  }
                  onChange={this.handleChange}
                  datafield='searchStandardSummaryQuarter'
                  value={this.state.searchStandardSummaryQuarter.toString()}
                  placeholder='Any Quarter'
                />
              </Form.Group>
              <Form.Group controlId='syear' as={Col}>
                <Form.Label>Year</Form.Label>
                <br />
                <SelectList
                  data={years.map((x) => {
                    return { name: x.name, value: x.id };
                  })
                  }
                  onChange={this.handleChange}
                  datafield='searchStandardSummaryYear'
                  value={this.state.searchStandardSummaryYear.toString()}
                  placeholder='Any Year'
                />
              </Form.Group>

              <Form.Group controlId='ssDbs' as={Col}>
                <Form.Label>Database</Form.Label>
                {this.props.standardSummaryDatabases && this.props.standardSummaryDatabases.length > 0 && (
                  <SelectList
                    data={
                      this.props.standardSummaryDatabases &&
                      this.props.standardSummaryDatabases.length > 0 &&
                      this.props.standardSummaryDatabases.map((x) => {
                        return { name: x.name, value: x.id };
                      })
                    }
                    onChange={this.handleChange}
                    datafield='searchStandardSummaryDatabase'
                    value={this.state.searchStandardSummaryDatabaseId.toString()}
                    placeholder='All Databases'
                  />
                )}
              </Form.Group>
              <Form.Group as={Col}></Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId='searchButton' style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  variant='primary'
                  onClick={(e) => this.handleSearchButton(e)}
                >
                  <i className='fas fa-search'></i> Search
                </Button>
                <Button
                  variant='secondary'
                  onClick={(e) => this.handleNewStandardSummaryButton(e)}
                  className='ml-2'
                >
                  <i className='far fa-plus-square'></i> New Standard Summary
                </Button>
                <div style={{ display: 'inline-block', width: 250 }} className='ml-2'>
                  {this.state.activeStandardSummaryProgress && isGranted(permissions.Developer, this.props.currentUser) &&
                    <ProgressBar
                      max={this.state.activeStandardSummaryProgress.totalPartsCount}
                      now={this.state.activeStandardSummaryProgress.completedPartsCount}
                      label={`(${this.state.activeStandardSummaryProgress.completedPartsCount}/${this.state.activeStandardSummaryProgress.totalPartsCount}) ${Math.round(this.state.activeStandardSummaryProgress.completedPartsCount / this.state.activeStandardSummaryProgress.totalPartsCount * 100)}%`}
                      style={{ height: 20 }}
                    />
                  }
                </div>
              </Form.Group>
            </Form.Row>
            <Form.Row />
          </Form>

          {this.props.results && this.props.results.length > 0 && (
            <DataTable
              id='tblStandardSummaryResults'
              data={this.props.results.sort((a, b) => {
                return (
                  new Date(b.createdDate).getTime() -
                  new Date(a.createdDate).getTime()
                );
              })}
              columns={columns}
              columnDefs={columnDefs}
              actionsColumn='first'
              select={false}
              order={[[2, 'desc']]}
              {...options}
            />
          )}
        </div>

        <Modal
          show={this.state.showNewStandardSummary}
          onHide={this.onCloseNewStandardSummaryModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>New Standard Summary</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Form>
                <Form.Group controlId='newDb'>
                  <Form.Label>
                    <strong>Database</strong>
                  </Form.Label>
                  {this.props.standardSummaryDatabases &&
                    this.props.standardSummaryDatabases.length > 0 && (
                      <SelectList
                        data={
                          this.props.standardSummaryDatabases &&
                          this.props.standardSummaryDatabases.length > 0 &&
                          this.props.standardSummaryDatabases.map((x) => {
                            return { name: x.name, value: x.id };
                          })
                        }
                        onChange={this.handleChange}
                        datafield='newStandardSummaryDatabase'
                        value={this.state.newStandardSummaryDatabaseId.toString()}
                        placeholder='Select a Database'
                      />
                    )}
                </Form.Group>
                <Form.Group controlId='exType'>
                  <Form.Label>
                    <strong>Date Type</strong>
                  </Form.Label>
                  {this.props.standardSummaryTypes &&
                    this.props.standardSummaryTypes.length > 0 && (
                      <SelectList
                        data={
                          this.props.standardSummaryTypes &&
                          this.props.standardSummaryTypes.length > 0 &&
                          this.props.standardSummaryTypes.map((x) => {
                            return { name: x.name, value: x.id };
                          })
                        }
                        onChange={this.handleChange}
                        datafield='standardSummaryType'
                        value={this.state.newStandardSummaryTypeId.toString()}
                        placeholder='Select a Type'
                      />
                    )}
                </Form.Group>
                {this.state.newStandardSummaryTypeId == 1 && (
                  <Form.Group controlId='month'>
                    <Form.Label>Month</Form.Label>
                    <br />
                    <SelectList
                      data={months.map((x) => {
                        return { name: x.name, value: x.id };
                      })
                      }
                      onChange={this.handleChange}
                      datafield='newStandardSummaryMonth'
                      value={this.state.newStandardSummaryMonth.toString()}
                      placeholder='Select a Month'
                    />
                  </Form.Group>
                )}
                {this.state.newStandardSummaryTypeId == 2 && (
                  <Form.Group controlId='quarter'>
                    <Form.Label>Quarter</Form.Label>
                    <br />
                    <SelectList
                      data={quarters.map((x) => {
                        return { name: x.name, value: x.id };
                      })
                      }
                      onChange={this.handleChange}
                      datafield='newStandardSummaryQuarter'
                      value={this.state.newStandardSummaryQuarter.toString()}
                      placeholder='Select a Quarter'
                    />
                  </Form.Group>
                )}
                {this.state.newStandardSummaryTypeId != -1 && (
                  <Form.Group controlId='year'>
                    <Form.Label>Year</Form.Label>
                    <br />
                    <SelectList
                      data={years.map((x) => {
                        return { name: x.name, value: x.id };
                      })
                      }
                      onChange={this.handleChange}
                      datafield='newStandardSummaryYear'
                      value={this.state.newStandardSummaryYear.toString()}
                      placeholder='Select a Year'
                    />
                  </Form.Group>
                )}
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.state.generatingStandardSummary && (
              <div>
                Working{'   '}
                <img
                  src={require('../../../src/assets/SmartAdmin/img/32/Marty.gif')}
                />
              </div>
            )}
            <Button
              variant='danger'
              onClick={this.onCloseNewStandardSummaryModal}
              disabled={this.state.generatingStandardSummary}
            >
              Cancel
            </Button>
            <Button
              variant='success'
              onClick={(e) => this.onCreateNewStandardSummary()}
              disabled={
                this.state.generatingStandardSummary ||
                this.state.newStandardSummaryTypeId == -1 ||
                this.state.newStandardSummaryYear == -1 ||
                (this.state.newStandardSummaryTypeId == 1 && this.state.newStandardSummaryMonth == -1) ||
                (this.state.newStandardSummaryTypeId == 2 && this.state.newStandardSummaryQuarter == -1)
              }
            >
              Generate Standard Summary
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment >
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    results: state.StandardSummary.results,
    standardSummaryTypes: state.StandardSummary.standardSummaryTypes,
    standardSummaryDatabases: state.StandardSummary.standardSummaryDatabases,
    elasticSearchURL: state.Application.elasticSearchURL,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  standardSummarySearch,
  getStandardSummaryTypes,
  getStandardSummaryDatabases,
  viewData,
};

export default connect(mapStateToProps, mapDispatchToProps)(StandardSummaryAdmin);
